<template>
  <div>
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <h5 class="card-title">Filtrar leilões</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Id</label>
              <input class="form-control" id="id" v-model="id" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_estado">UF</label>

              <select class="custom-select rounded-0" id="endereco_estado" v-model="estado" @change="buscarCidades()">
                <option value=""></option>
                <option v-for="estado in estados" :key="estado" :value="estado.id">
                  {{ estado.nome }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_cidade">Cidade</label>

              <select class="custom-select rounded-0" id="endereco_cidade" v-model="cidade">
                <option v-for="cidade in cidades" :key="cidade" :value="cidade.id">
                  {{ cidade.nome }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="comitente">Comitentes</label>

              <select class="custom-select rounded-0" id="comitente" v-model="comitente">
                <option v-for="comitente in comitentes" :key="comitente" :value="comitente.id">
                  {{ comitente.nome }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="cpf_cnpj">Executado</label>
              <input class="form-control" id="executado" v-model="executado" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="endereco_cidade">Processo</label>

              <!--
              <select class="custom-select rounded-0" id="endereco_cidade" v-model="processo">
                <option v-for="processo in processos" :key="processo" :value="processo">
                  {{ processo.processo_numero }}
                </option>
              </select>
              -->

              <v-autocomplete
                id="processo"
                variant="outlined"
                :items="processos"
                item-title="processo_numero"
                return-object
                v-model="processo"
                density="compact"
              ></v-autocomplete>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="cpf_cnpj">Título</label>
              <input class="form-control" id="titulo" v-model="titulo" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="cpf_cnpj">Descrição</label>
              <input class="form-control" id="descricao" v-model="descricao" />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label for="leilao_local">Local do leilão</label>
              <input class="form-control" id="leilao_local" v-model="local" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="tipo">Tipo do leilão</label>

              <select class="custom-select rounded-0" id="tipo" v-model="tipo">
                <option value=""></option>
                <option value="extra">Extra</option>
                <option value="judicial">Judicial</option>
              </select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="teste">Leilão de teste</label>

              <select class="custom-select rounded-0" id="teste" v-model="teste">
                <option :value="0">Não</option>
                <option :value="1">Sim</option>
              </select>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <button type="button" class="btn btn-primary" @click="buscarLeiloes()">Buscar</button>

              <button type="button" class="btn btn-default" @click="limparFiltros" style="margin-left: 15px">Limpar filtros</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA DE LEILÕES -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Leilões</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th style="text-align: center">Id</th>
              <th>Informações</th>
              <th>Detalhes</th>
              <th>Atualizações</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(leilao, index) in leiloes" :key="leilao" @contextmenu.prevent="onRightClick($event, leilao)" @click="hideMenu()">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Id" style="text-align: center">
                <img width="90px" height="50px" :src="getImagePath(leilao)" />
                <br />
                <a :href="'/admin/leilao/' + leilao.id">
                  <i class="fa fa-pen"></i>
                  {{ leilao.id }} &nbsp;
                </a>
                <br />

                <a @click="getUrlLeilao(leilao)" href="#">Site</a>
              </td>

              <td data-label="Informações" style="text-transform: uppercase">
                <strong>{{ leilao.cidade + "/" + leilao.estado }}</strong>
                <br />
                <strong>{{ leilao.leilao_titulo }}</strong>
                <br />
                {{ leilao.leilao_descricao }}
                <br />
                {{ leilao.comitente }}
                <br />
                <strong>
                  Tipo (modalidade)
                  <button
                    @click="showModalidadeInfo()"
                    type="button"
                    class="btn btn-default btn-sm"
                    style="border-radius: 60%; font-size: 12px; font-weight: bold; padding-top: 1px; padding-bottom: 1px"
                  >
                    ?
                  </button>
                  :
                </strong>
                &nbsp;{{ leilao.leilao_tipo }}&nbsp;&nbsp;&nbsp;
                <strong>Visitas:</strong>
                <span style="margin-left: 2px" class="right badge badge-success">{{ leilao.leilao_visits }}</span>
                <br />
                <strong>Lotes:</strong>
                <span style="margin-left: 2px" v-if="leilao.lotes" class="right badge badge-success">
                  {{ leilao.lotes.length }}
                </span>
                <span v-else class="right badge badge-success">0</span>
                <!-- HABILITADOS -->
                <strong style="margin-left: 12px">Habilitados:</strong>
                <span
                  data-toggle="modal"
                  data-target="#visualizar-habilitacoes"
                  @click="leilao_selecionado = leilao"
                  v-if="leilao.habilitacoes"
                  class="right badge badge-success"
                  style="margin-left: 2px; cursor: pointer"
                >
                  {{ leilao.habilitacoes.length }}
                </span>
                <span v-else class="right badge badge-success" style="margin-left: 2px">0</span>
                <br />
                {{ leilao.leilao_url_rastreavel }}
                <br />
              </td>

              <td data-label="Detalhes">
                <div v-if="leilao.leilao_1_data">
                  Realizado:
                  <input style="margin-right: 10px" type="checkbox" v-model="leilao.leilao_1_realizado" @change="changePraca(leilao, 1)" />
                  <strong>1.&nbsp; {{ formatDate(leilao.leilao_1_data) + "h" }}</strong>
                  <br />
                </div>

                <div v-if="leilao.leilao_2_data">
                  Realizado:
                  <input style="margin-right: 10px" type="checkbox" v-model="leilao.leilao_2_realizado" @change="changePraca(leilao, 2)" />
                  <strong>
                    2.&nbsp; {{ formatDate(leilao.leilao_2_data) + "h" }}
                    <br />
                  </strong>
                </div>

                <div v-if="leilao.leilao_3_data">
                  Realizado:
                  <input style="margin-right: 10px" type="checkbox" v-model="leilao.leilao_3_realizado" @change="changePraca(leilao, 3)" />
                  <strong>
                    3.&nbsp; {{ formatDate(leilao.leilao_3_data) + "h" }}
                    <br />
                  </strong>
                </div>

                <div v-if="leilao.leilao_4_data">
                  Realizado:
                  <input style="margin-right: 10px" type="checkbox" v-model="leilao.leilao_4_realizado" @change="changePraca(leilao, 4)" />
                  <strong>
                    4.&nbsp; {{ formatDate(leilao.leilao_4_data) + "h" }}
                    <br />
                  </strong>
                </div>
                <br />
                Oculto:
                <input type="checkbox" id="agreeTerms" name="terms" value="agree" v-model="leilao.leilao_oculto" @change="ocultarLeilao(leilao)" />
                &nbsp;&nbsp; Retirado:
                <input type="checkbox" id="agreeTerms" name="terms" value="agree" v-model="leilao.leilao_retirado" @change="changeStatus(leilao)" />
                &nbsp;&nbsp; Encerrado:
                <input type="checkbox" id="agreeTerms" name="terms" value="agree" v-model="leilao.leilao_encerrado" @change="changeStatus(leilao)" />
                &nbsp;&nbsp; Suspenso:
                <input type="checkbox" id="agreeTerms" name="terms" value="agree" v-model="leilao.leilao_suspenso" @change="changeStatus(leilao)" />
                &nbsp;&nbsp; &nbsp;&nbsp; Pausado:
                <input type="checkbox" id="agreeTerms" name="terms" value="agree" v-model="leilao.leilao_pausado" @change="changeStatus(leilao)" />
                &nbsp;&nbsp;
              </td>

              <td data-label="Atualizações">
                Criado há:
                <strong>{{ calcularValor(leilao.created_at) }}</strong>
                <br />
                Atualizado há:
                <strong>{{ calcularValor(leilao.updated_at) }}</strong>
                <br />
              </td>

              <td>
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a :href="getUrlEdit(leilao)" class="dropdown-item">
                    <i class="fa-solid fa-pen"></i>
                    &nbsp;&nbsp; Editar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a :href="getUrlListarLotes(leilao)" class="dropdown-item">
                    <i class="fa-solid fa-bars"></i>
                    &nbsp;&nbsp; Listar lotes
                  </a>
                  <div class="dropdown-divider"></div>
                  <a :href="getUrlAddLote(leilao)" class="dropdown-item">
                    <i class="fa-solid fa-plus"></i>
                    &nbsp;&nbsp; Adicionar lote
                  </a>
                  <div class="dropdown-divider"></div>
                  <a :href="getUrlDocumentos(leilao)" class="dropdown-item">
                    <i class="fa-solid fa-file"></i>
                    &nbsp;&nbsp; Documentos
                  </a>
                  <div class="dropdown-divider"></div>
                  <a :href="getUrlFotos(leilao)" class="dropdown-item">
                    <i class="fa-solid fa-image"></i>
                    &nbsp;&nbsp; Fotos
                  </a>
                  <div class="dropdown-divider"></div>
                  <a :href="getUrlImportarLotes(leilao)" class="dropdown-item">
                    <i class="fa-solid fa-upload"></i>
                    &nbsp;&nbsp; Importar lotes
                  </a>
                  <div class="dropdown-divider"></div>
                  <a :href="getUrlLogs(leilao)" class="dropdown-item">
                    <i class="fa-solid fa-book"></i>
                    &nbsp;&nbsp; Logs
                  </a>
                  <div class="dropdown-divider"></div>
                  <a :href="getUrlPub(leilao)" class="dropdown-item">
                    <i class="fa-solid fa-newspaper"></i>
                    &nbsp;&nbsp; Publicação oficial
                  </a>
                  <div class="dropdown-divider"></div>
                  <a href="#" @click="validarExcluirLeilao(leilao)" class="dropdown-item">
                    <i class="fa-solid fa-trash"></i>
                    &nbsp;&nbsp; Excluir
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div
          id="newMenu"
          style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
          class="dropdown-menu-lg dropdown-menu-right"
        >
          <div class="dropdown-divider"></div>
          <a :href="getUrlEdit(leilao_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-pen"></i>
            &nbsp;&nbsp; Editar
          </a>

          <div class="dropdown-divider"></div>
          <a :href="getUrlListarLotes(leilao_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-bars"></i>
            &nbsp;&nbsp; Listar lotes
          </a>
          <div class="dropdown-divider"></div>
          <a :href="getUrlAddLote(leilao_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-plus"></i>
            &nbsp;&nbsp; Adicionar lote
          </a>
          <div class="dropdown-divider"></div>
          <a :href="getUrlDocumentos(leilao_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-file"></i>
            &nbsp;&nbsp; Documentos
          </a>
          <div class="dropdown-divider"></div>
          <a :href="getUrlFotos(leilao_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-image"></i>
            &nbsp;&nbsp; Fotos
          </a>
          <div class="dropdown-divider"></div>
          <a :href="getUrlImportarLotes(leilao_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-upload"></i>
            &nbsp;&nbsp; Importar lotes
          </a>
          <div class="dropdown-divider"></div>
          <a :href="getUrlLogs(leilao_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-book"></i>
            &nbsp;&nbsp; Logs
          </a>
          <div class="dropdown-divider"></div>
          <a :href="getUrlPub(leilao_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-newspaper"></i>
            &nbsp;&nbsp; Publicação oficial
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" @click="validarExcluirLeilao(leilao_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-trash"></i>
            &nbsp;&nbsp; Excluir
          </a>
        </div>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + leiloes.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>

    <!-- MODAL HABILITADOS -->
    <div
      class="modal fade"
      id="visualizar-habilitacoes"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
      v-if="leilao_selecionado && leilao_selecionado.habilitacoes && leilao_selecionado.habilitacoes.length"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Visualizar habilitações</h4>
              <br />
              <div class="card card-primary">
                <div class="card-body">
                  <table class="table table-hover text-nowrap">
                    <thead>
                      <tr>
                        <th>Seq</th>
                        <th>Apelido</th>
                        <th>Nome</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(habilitacao, index) in leilao_selecionado.habilitacoes" :key="habilitacao">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + habilitacao.user_id">{{ habilitacao.apelido }}</a>
                        </td>
                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + habilitacao.user_id">{{ habilitacao.nome_completo }}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="card-footer">
                  <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL -->
    <div
      class="modal fade"
      id="visualizar-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Visualizar leilão</h4>
              <br />
              <div class="card card-primary">
                <div class="card-header">
                  <h3 class="card-title" style="color: white">Visualizar leilão</h3>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- ATIVAR REGRESSIVA -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="leilao_acionar_regressiva_apos">Ativar regressiva faltando (s)</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_acionar_regressiva_apos"
                          placeholder="Tempo em segundos"
                          v-model="leilao_selecionado.leilao_acionar_regressiva_apos"
                        />
                      </div>
                    </div>

                    <!-- REINICIAR TEMPO -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="leilao_regressiva">Reiniciar o tempo em (s)</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_regressiva"
                          placeholder="Tempo em segundos"
                          v-model="leilao_selecionado.leilao_regressiva"
                        />
                      </div>
                    </div>

                    <!-- INTERVALO -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="leilao_lote_intervalo">Intervalo entre os lotes (s)</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_lote_intervalo"
                          placeholder="Tempo em segundos"
                          v-model="leilao_selecionado.leilao_lote_intervalo"
                        />
                      </div>
                    </div>

                    <!-- TEMPO PRIMEIRO LOTE -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="leilao_primeiro_lote_margem_tempo">Primeiro lote inicia com (s)</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_primeiro_lote_margem_tempo"
                          placeholder="Tempo em segundos"
                          v-model="leilao_selecionado.leilao_primeiro_lote_margem_tempo"
                        />
                      </div>
                    </div>

                    <!-- LEILOEIRO RESPONSÁVEL -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="endereco_cidade">Leiloeiro responsável</label>
                        <label for="endereco_cidade" class="form-control">
                          {{ leilao_selecionado.leiloeiro_matricula + "- " + leilao_selecionado.leiloeiro }}
                        </label>
                      </div>
                    </div>

                    <!-- TAXA -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_taxa_administrativa">Taxa administrativa</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_taxa_administrativa"
                          placeholder="0.00"
                          v-model="leilao_selecionado.leilao_taxa_administrativa"
                          type="number"
                          step="0.01"
                        />
                      </div>
                    </div>

                    <!-- ENDERECO ESTADO -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="endereco_estado">UF</label>

                        <label for="endereco_cidade" class="form-control">
                          {{ leilao_selecionado.estado }}
                        </label>
                      </div>
                    </div>

                    <!-- ENDERECO CIDADE -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="endereco_cidade">Cidade</label>

                        <label for="endereco_cidade" class="form-control">
                          {{ leilao_selecionado.cidade }}
                        </label>
                      </div>
                    </div>

                    <!-- COMITENTE -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="comitente">Comitente</label>
                        <label for="comitente" class="form-control">
                          {{ leilao_selecionado.comitente }}
                        </label>
                      </div>
                    </div>

                    <!-- MODO GENÉRICO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_modo_generico">Modo genérico</label>

                        <label for="leilao_modo_generico" class="form-control">
                          {{ convertTiny(leilao_selecionado.leilao_modo_generico) }}
                        </label>
                      </div>
                    </div>

                    <!-- TITULO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_titulo">Título</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_titulo"
                          placeholder="Título"
                          v-model="leilao_selecionado.leilao_titulo"
                        />
                      </div>
                    </div>

                    <!-- DESCRIÇÃO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_descricao">Descrição</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_descricao"
                          placeholder="Título"
                          v-model="leilao_selecionado.leilao_descricao"
                        />
                      </div>
                    </div>

                    <!-- LOCAL DO LEILÃO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_local">Local do leilão</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_local"
                          placeholder="Título"
                          v-model="leilao_selecionado.leilao_local"
                        />
                      </div>
                    </div>

                    <!-- TIPO LEILAO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_tipo">Tipo do leilão</label>

                        <input disabled="true" class="form-control" id="leilao_tipo" placeholder="Título" v-model="leilao_selecionado.leilao_tipo" />
                      </div>
                    </div>

                    <!-- NÚMERO DE PRAÇAS -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_num_pracas">Número de praças</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_num_pracas"
                          placeholder="Título"
                          v-model="leilao_selecionado.leilao_num_pracas"
                        />
                      </div>
                    </div>

                    <!-- INFORMAÇÕES GERAIS -->
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label for="leilao_info_geral">Informações gerais</label>
                        <br />
                        <div for="leilao_num_pracas" v-html="leilao_selecionado.leilao_info_geral"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <button data-toggle="modal" id="cancelar" data-target="#visualizar-modal" class="btn btn-danger">Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["estados"],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      leilao_selecionado: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      leiloes: [],
      cidades: [],
      id: "",
      estado: "",
      cidade: "",
      comitente: "",
      titulo: "",
      descricao: "",
      local: "",
      tipo: "",
      teste: 0,
      executado: "",
      processo: "",
      comitentes: "",
      processos: "",
    };
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    let page = urlParams.get("page");

    console.log("Pagina");
    console.log(page);

    if (page) {
      this.pagina_atual = Number(page);
    }

    console.log("Pagina atual");
    console.log(this.pagina_atual);

    this.buscarLeiloes(true);

    this.buscarComitentes();
    this.buscarprocessos();
  },

  methods: {
    validarExcluirLeilao(leilao) {
      console.log("V1");
      console.log(leilao);

      this.leilao_selecionado = leilao;

      let data = {
        id: this.leilao_selecionado.id,
      };

      console.log("Validando");
      console.log(data);

      axios
        .post(`/admin/delete_leilao/validate`, data)
        .then((response) => {
          console.log("Resposta");
          console.log(response);

          if (response.data.success) {
            let html = "Deseja apagar o Leilão ID " + this.leilao_selecionado.id + "? Essa ação é irreversível.";

            this.$swal
              .fire({
                title: "Confirmação",
                html: html,
                icon: "warning",
                padding: "1.5em",
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, quero deletar!",
              })
              .then((result) => {
                if (result.value) {
                  this.isLoading = true;

                  let data = {
                    id: this.leilao_selecionado.id,
                    pergunta: html,
                  };

                  axios
                    .post(`/admin/delete_leilao/delete`, data)
                    .then((response) => {
                      this.showSuccessMessage("Leilão deletado com sucesso!");
                      this.buscarLeiloes();
                    })
                    .catch((error) => {
                      this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                      console.log(error.response.data);
                    });
                }
              });
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarComitentes() {
      let data = {
        inicio: 0,
        tamanho: 100000,
      };

      axios
        .post(`/admin/comitente/search`, data)
        .then((response) => {
          this.comitentes = response.data.comitentes;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarprocessos() {
      let data = {
        inicio: 0,
        tamanho: 100000,
      };

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/admin/processos/search`, data)
        .then((response) => {
          this.processos = response.data.processos;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    showModalidadeInfo() {
      this.$swal
        .fire({
          icon: "info",
          title: "Tipo (modalidade)",
          padding: "1.5em",
          text: 'Esse campo aparece na tela do usuário como "Modalidade".',
        })
        .then(function () {});
    },

    getUrlLeilao(leilao) {
      console.log("Lotes");
      console.log(leilao.lotes);

      if (leilao.lotes) {
        let qtd_lotes_nao_ocultos = 0;
        let lote_disponivel_id = null;

        for (let i = 0; i < leilao.lotes.length; i++) {
          if (leilao.lotes[i].lote_oculto == 0) {
            qtd_lotes_nao_ocultos++;

            if (!lote_disponivel_id) {
              lote_disponivel_id = leilao.lotes[i].id;
            }
          }
        }

        console.log("Não ocultos " + qtd_lotes_nao_ocultos);

        if (qtd_lotes_nao_ocultos > 1) {
          window.open("/leilao/" + leilao.id + "/lotes");
        } else {
          if (lote_disponivel_id) {
            window.open("/lote/" + lote_disponivel_id);
          } else {
            this.showErrorMessageWithButton("Ops...", "Este leilão não possui nenhum lote disponível para visualização.");
          }
        }
      } else {
        this.showErrorMessageWithButton("Ops...", "Este leilão não possui nenhum lote disponível para visualização.");
      }
    },

    changePraca(leilao, num_praca) {
      console.log(leilao.leilao_1_realizado);
      console.log(num_praca);

      this.leilao_selecionado = leilao;

      let valor = -1;

      //FECHANDO PRACA
      if (num_praca == 2 && leilao.leilao_2_realizado && !leilao.leilao_1_realizado) {
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else if (num_praca == 3 && leilao.leilao_3_realizado && !leilao.leilao_2_realizado) {
        leilao.leilao_3_realizado = false;
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else if (num_praca == 4 && leilao.leilao_4_realizado && !leilao.leilao_3_realizado) {
        leilao.leilao_4_realizado = false;
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else {
        if (num_praca == 1) {
          valor = this.convertToTiny(leilao.leilao_1_realizado);
        } else if (num_praca == 2) {
          valor = this.convertToTiny(leilao.leilao_2_realizado);
        } else if (num_praca == 3) {
          valor = this.convertToTiny(leilao.leilao_3_realizado);
        } else if (num_praca == 4) {
          valor = this.convertToTiny(leilao.leilao_4_realizado);
        }

        let data = {
          leilao_id: leilao.id,
          num_praca: num_praca,
          valor: valor,
        };

        console.log(data);

        axios
          .post(`/admin/leilao/fechar_praca`, data)
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              if (response.data.leilao_aberto) {
                leilao.leilao_encerrado = false;
              }

              if (response.data.leilao_encerrado) {
                leilao.leilao_encerrado = true;
              }

              this.showSuccessMessage("Status atualizado");
              this.forceDisconnect();
            } else {
              console.log("Erro na request");
              this.showErrorMessageWithButton("Ops...", response.data.msg);
              this.buscarLeiloes();
            }

            //window.location.reload();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
            this.isLoading = false;
          });
      }
    },

    forceDisconnect() {
      let data = {
        leilao_id: this.leilao_selecionado.id,
      };

      axios.post(process.env.MIX_VUE_APP_AUDITORIO + `/emit_disconnect`, data).then((response) => {});
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, leilao) {
      this.leilao_selecionado = leilao;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 650;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    changeStatus(leilao, atual) {
      console.log(leilao);

      this.leilao_selecionado = leilao;

      let data = {
        leilao_id: leilao.id,
        leilao_retirado: this.convertToTiny(leilao.leilao_retirado),
        leilao_encerrado: this.convertToTiny(leilao.leilao_encerrado),
        leilao_suspenso: this.convertToTiny(leilao.leilao_suspenso),
        leilao_pausado: this.convertToTiny(leilao.leilao_pausado),
      };

      console.log(data);

      axios
        .post(`/admin/leilao/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");
          this.forceDisconnect();

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    ocultarLeilao(leilao) {
      let mensagem = "";

      if (!leilao.leilao_oculto) {
        mensagem =
          "<h3 style='color:#616060'>Ao <b style='color: green'>desocultar</b> o leilão, todos os lotes também serão desocultados. <br/><b>Confirma sua escolha?</b></h3>";
      } else {
        mensagem =
          "<h3 style='color:#616060'>Ao <b style='color: red'>ocultar</b> o leilão, todos os lotes serão marcados com oculto. <br/><b>Confirma sua escolha?</b></h3>";
      }

      this.$swal
        .fire({
          title: mensagem,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, confirmar!",
        })
        .then((result) => {
          if (result.value) {
            let data = {
              leilao_id: leilao.id,
              leilao_oculto: this.convertToTiny(leilao.leilao_oculto),
            };

            console.log(data);

            axios
              .post(`/admin/leilao/ocultar_leilao`, data)
              .then((response) => {
                this.showSuccessMessage("Status atualizado");

                //window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
                this.isLoading = false;
              });
          } else {
            leilao.leilao_oculto = !leilao.leilao_oculto;
          }
        });
    },

    handler() {
      alert("Right!");
    },

    getUrlImportarLotes(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes/importar";
    },

    getUrlFotos(leilao) {
      if (leilao.lotes && leilao.lotes.length) {
        return "/admin/fotos/" + leilao.lotes[0].id + "";
      }
    },

    getUrlPub(leilao) {
      return "/admin/publicacao/" + leilao.id + "";
    },

    getUrlDocumentos(leilao) {
      return "/admin/documentos/" + leilao.id + "";
    },

    getUrlListarLotes(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes";
    },

    getUrlAddLote(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes/cadastrar_lote";
    },

    getUrlLogs(leilao) {
      return "/admin/leilao/" + leilao.id + "/logs";
    },

    limparFiltros() {
      this.id = "";
      this.estado = "";
      this.cidade = "";
      this.comitente = "";
      this.titulo = "";
      this.descricao = "";
      //this.local = "EXCLUSIVAMENTE ONLINE";
      this.local = "";
      this.tipo = "";
      this.teste = 0;
      this.executado = "";
      this.processo = "";

      window.history.replaceState(null, null, "?page=1");

      this.buscarLeiloes();
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(leilao) {
      this.leilao_selecionado = leilao;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      /*const urlParams = new URLSearchParams(window.location.search);

      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + pagina);

        this.buscarLeiloes(true);
      }
        */

      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + pagina);

        this.buscarLeiloes(true);
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + this.max_page);

        this.buscarLeiloes(true);
      }
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;

          this.buscarLeiloes();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarLeiloes(manter_inicio) {
      if (!manter_inicio || manter_inicio == null) {
        this.inicio = 0;
        this.pagina_atual = 1;
      }

      console.log("Manter?");
      console.log(manter_inicio);

      this.isLoading = true;

      let data = {
        id: this.id,
        estado_id: this.estado,
        cidade_id: this.cidade,
        comitente_id: this.comitente,
        titulo: this.titulo,
        descricao: this.descricao,
        local: this.local,
        tipo: this.tipo,
        teste: this.teste,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        executado: this.executado,
        processo_id: this.processo.id,
      };

      console.log(data);

      axios
        .post(`/admin/leilao/search`, data)
        .then((response) => {
          this.leiloes = response.data.leiloes;
          this.total = response.data.total;

          console.log("Leilões");
          console.log(this.leiloes);

          this.pagination(response.data);

          //CONVERTER STATUS
          for (let i = 0; i < this.leiloes.length; i++) {
            if (this.leiloes[i].leilao_oculto == 1) {
              this.leiloes[i].leilao_oculto = true;
            } else {
              this.leiloes[i].leilao_oculto = false;
            }

            if (this.leiloes[i].leilao_encerrado == 1) {
              this.leiloes[i].leilao_encerrado = true;
            } else {
              this.leiloes[i].leilao_encerrado = false;
            }

            if (this.leiloes[i].leilao_retirado == 1) {
              this.leiloes[i].leilao_retirado = true;
            } else {
              this.leiloes[i].leilao_retirado = false;
            }

            if (this.leiloes[i].leilao_suspenso == 1) {
              this.leiloes[i].leilao_suspenso = true;
            } else {
              this.leiloes[i].leilao_suspenso = false;
            }

            if (this.leiloes[i].leilao_pausado == 1) {
              this.leiloes[i].leilao_pausado = true;
            } else {
              this.leiloes[i].leilao_pausado = false;
            }

            if (this.leiloes[i].leilao_1_realizado == 1) {
              this.leiloes[i].leilao_1_realizado = true;
            } else {
              this.leiloes[i].leilao_1_realizado = false;
            }

            if (this.leiloes[i].leilao_2_realizado == 1) {
              this.leiloes[i].leilao_2_realizado = true;
            } else {
              this.leiloes[i].leilao_2_realizado = false;
            }

            if (this.leiloes[i].leilao_3_realizado == 1) {
              this.leiloes[i].leilao_3_realizado = true;
            } else {
              this.leiloes[i].leilao_3_realizado = false;
            }

            if (this.leiloes[i].leilao_4_realizado == 1) {
              this.leiloes[i].leilao_4_realizado = true;
            } else {
              this.leiloes[i].leilao_4_realizado = false;
            }
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getImagePath(logo) {
      if (logo.path) {
        if (logo && logo.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + logo.path + "/" + logo.arquivo;
        } else if ((logo && logo.path.includes("rochaleiloes")) || (logo && logo.arquivo.includes("fotos_"))) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + logo.path + "/" + logo.arquivo;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
        }
      }
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLeiloes(true);
    },

    deletar(leilao) {
      this.leilao_selecionado = leilao;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de leilao<b><br/>" + this.leilao_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.leilao_selecionado.id,
            };

            axios
              .post(`/admin/leilao/delete`, data)
              .then((response) => {
                this.showSuccessMessage("leilao deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>

<style scoped>
v-autocomplete {
  height: 40px !important;
  max-height: 40px !important;
  margin: 0px;
  padding: 0px;
}
</style>
